export default "__VITE_ASSET__Bh5yuLWI__"